import { TContextByKey, IGetContextOptions, ISetContextOptions } from '../models/context';

export class ContextStore {
	contextByKey: TContextByKey = {};
	get(options: IGetContextOptions) {
		const { contextParentKey, contextKey } = options;
		return this.contextByKey && this.contextByKey[contextParentKey] && this.contextByKey[contextParentKey][contextKey];
	}
	set(options: ISetContextOptions) {
		const { contextParentKey, contextKey, value } = options;
		if (contextParentKey && contextKey && value) {
			if (!this.contextByKey) {
				this.contextByKey = {};
			}
			if (!this.contextByKey[contextParentKey]) {
				this.contextByKey[contextParentKey] = {};
			}
			this.contextByKey[contextParentKey][contextKey] = value;
		}
	}
}